import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

export const ClientOnlyLazySearchInternshipRefinements = clientOnlyLazy(() =>
  import('./SearchInternshipRefinements').then((m) => ({
    default: m.SearchInternshipRefinements,
  })),
);
